import { action, ActionType } from 'typesafe-actions';
import ActionTypes from './types';

export const selectCompany = {
  set: (company: string) => action(ActionTypes.SELECT_COMPANY, company),
};

export type SelectCompany = ActionType<typeof selectCompany>;
